// actions.js
import { createAction } from '@reduxjs/toolkit';

export const setNextPageId = createAction('SET_NEXT_PAGE_ID');
export const setPrevPageId = createAction('SET_PREV_PAGE_ID');
